// src/components/ServiceCard.js
import React from 'react';
import { CheckCircle } from 'lucide-react'; // Import necessary icons

function ServiceCard({ title, description, icon: Icon, items, features }) {
  // Basic validation in case Icon is not passed correctly
  const IconComponent = Icon || (() => null);

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-8 flex flex-col relative h-full"> {/* Ensure card takes full height */}

      {/* Header */}
      <div className="flex items-center mb-4">
        <div className="bg-indigo-100 text-indigo-600 rounded-full p-3 mr-4">
          <IconComponent size={24} strokeWidth={1.5} />
        </div>
        <h3 className="text-2xl font-semibold text-gray-800">{title}</h3>
      </div>
      <p className="text-gray-600 mb-6">{description}</p>

      {/* Main Offerings/Items List with Checkmarks */}
      {/* Ensure items is an array before processing */}
      {Array.isArray(items) && items.length > 0 && (
        <div className="mb-6 pt-2 space-y-3 flex-grow"> {/* Added flex-grow */}
          {/* Handling different structures for items (list vs nested list) */}
          {title === "Consulting Services" ? (
            items.map((item, index) => (
              <div key={index} className="mb-3">
                <h5 className="font-medium text-gray-700 mb-1">{item.title}</h5>
                {/* Ensure item.points is an array */}
                {Array.isArray(item.points) && (
                    <ul className="space-y-2">
                    {item.points.map((point, pIndex) => (
                        <li key={pIndex} className="flex items-start">
                        <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-600 text-sm">{point}</span>
                        </li>
                    ))}
                    </ul>
                )}
              </div>
            ))
          ) : (
            <ul className="space-y-2">
              {items.map((item, index) => (
                 <li key={index} className="flex items-start">
                   <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                   <span className="text-gray-600 text-sm">{item}</span>
                 </li>
              ))}
            </ul>
          )}
        </div>
      )}


      {/* Key Features List with Checkmarks (if features exist) */}
      {/* Ensure features is an array before processing */}
      {Array.isArray(features) && features.length > 0 && (
        // Use mt-auto to push features to bottom if content above is short
        <div className="mt-auto mb-0 space-y-3 pt-4 border-t border-gray-200">
          <h4 className="font-semibold text-gray-700 mb-2 text-sm uppercase tracking-wide">Key Features:</h4>
          <ul className="space-y-2">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <CheckCircle className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-sm">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

    </div>
  );
}

export default ServiceCard;

